import React from "react";
import {Navigate} from "react-router-dom";
import {Typography} from "@mui/material";
import PageTitle from "../../../global/components/PageTitle";
import ChangesDataTable from "../components/ChangesDataTable";
import useGetAllChangesForAdmin from "../queries/useGetAllChangesForAdmin";

const AllChanges = () => {

    const {data: changes, isError} = useGetAllChangesForAdmin();

    if (isError) return <Navigate to="/login"/>

    if (!changes) return <h1>Keine Änderungen</h1>

    return (
        <>
            <Typography variant="h5" sx={{paddingVertical: 3}}>Alle Änderungen</Typography>
            <ChangesDataTable changes={changes}/>
        </>
    )
}

export default AllChanges;